import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export const COMPANY_DEFAULT = { product_name: "GestaCV", legal_name: "", short_name: "", nif: "", address: "", email: "", phone: "", whatsapp: "", sales_email: "" };

let cache = null;
let pending = null;

export function refreshCompany() {
  pending = axios.get(`${API}/public/legal`).then((r) => { cache = { ...COMPANY_DEFAULT, ...r.data }; return cache; })
    .catch(() => cache || COMPANY_DEFAULT);
  return pending;
}

export function useCompany() {
  const [c, setC] = useState(cache || COMPANY_DEFAULT);
  useEffect(() => {
    if (cache) return;
    (pending || refreshCompany()).then(setC);
  }, []);
  return c;
}

export const copyrightLine = (c) =>
  `© ${new Date().getFullYear()} ${c.product_name || "GestaCV"} é um produto da ${c.legal_name} — NIF ${c.nif}. Todos os direitos reservados.`;
